import Vue from 'vue';
import Vuex from 'vuex';
import * as user from './modules/user'
import * as app from './modules/app'
import * as personalInfo from './modules/personal-info'
import * as consolidatedIncomeTaxtatement from './modules/consolidated-income-tax-statement'
import * as specialaddiTionalDeductions from './modules/special-additional-deductions'
import * as declarationClassifiedIncome from './modules/declaration-classified-income'






Vue.use(Vuex);

let states = mergeStateModules(user, app ,personalInfo,consolidatedIncomeTaxtatement,specialaddiTionalDeductions,declarationClassifiedIncome);

function mergeStateModules(...modules) {
  let mappedModules = [];
  modules.forEach(m => {
    if (m.default instanceof Array) {
      mappedModules.push(...m.default)
    } else {
      mappedModules.push(m);
    }
  });
  return {
    namespaced: true,
    modules: {
      ...mergeStates(mappedModules)
    }
  }
}

function mergeStates(states) {
  let mergedModules = {};
  states.forEach(item => {
    if (!item.moduleId) {
      console.error("没有声明moduleId", item);
      return;
    }
    mergedModules[item.moduleId] = mergeState(item);
  });
  return mergedModules;
}

function mergeState(stateObj) {
  stateObj = stateObj.default ? stateObj.default : stateObj;
  return {
    namespaced: true,
    state: stateObj.state,
    actions: stateObj.actions,
    mutations: stateObj.mutations,
    getters:stateObj.getters
  };
}


const store = new Vuex.Store({
  ...states
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js